/**
 * @generated SignedSource<<cdbf256cdaedd94c0c173bb18d3ba426>>
 * @relayHash 839317990eafb827a0b53ee78dada942
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID fd22deb0d7d19587d2277bf4635b93317ee9adc303480cbca9a38118af1b3f64

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { notificationTableQuery } from './notificationTableQuery.graphql';

const node: PreloadableConcreteRequest<notificationTableQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "fd22deb0d7d19587d2277bf4635b93317ee9adc303480cbca9a38118af1b3f64",
    "metadata": {},
    "name": "notificationTableQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
